/* Good Travel · Formulario «Solicitar oferta»: pasos, calendario propio, prefijo con bandera,
   email comprobado y una sorpresa al enviar. Llega a Gmail igual que el presupuesto. */
(function () {
'use strict';
var form = document.getElementById('gt-form-oferta');
if (!form || form.dataset.of) return;
form.dataset.of = '1';
var root = (form.parentNode && form.parentNode.closest('[id^="gt-"]')) || form.parentNode;
var KEY = 'gt-oferta-ultima';
var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
function $(s, el) { return (el || form).querySelector(s); }
function $$(s, el) { return Array.prototype.slice.call((el || form).querySelectorAll(s)); }
function F(k) { return $('[data-of="' + k + '"]'); }
var MESES = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];
var MES3 = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'];
var DIAS = ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'];
function corta(d) { return DIAS[d.getDay()] + ' ' + d.getDate() + ' ' + MES3[d.getMonth()]; }
function larga(d) { return corta(d) + ' ' + d.getFullYear(); }
function ddmm(d) { return ('0' + d.getDate()).slice(-2) + '/' + ('0' + (d.getMonth() + 1)).slice(-2) + '/' + d.getFullYear(); }
function clave(d) { return d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate(); }
function dia(d) { return new Date(d.getFullYear(), d.getMonth(), d.getDate()); }
function mismo(a, b) { return a && b && a.getTime() === b.getTime(); }
function noches(a, b) { return Math.round((b - a) / 864e5); }
function store(v) { try { if (v === undefined) return JSON.parse(sessionStorage.getItem(KEY) || 'null'); sessionStorage.setItem(KEY, JSON.stringify(v)); } catch (e) { return null; } }

/* =================== Pantalla de éxito: la sorpresa =================== */
var done = $('[data-of-done]');
if (done) {
  var last = store();
  if (last) {
    if (last.nombre) $('[data-of-title]').textContent = '¡Gracias, ' + last.nombre + '! Tu viaje ya está en marcha';
    if (last.ref) $('[data-of-t="ref"]').textContent = last.ref;
    if (last.fechas) $('[data-of-t="fechas"]').textContent = last.fechas;
    if (last.pax) $('[data-of-t="pax"]').textContent = last.pax;
    var wa = $('[data-of-wa]');
    if (wa) wa.href = wa.href.split('?')[0] + '?text=' + encodeURIComponent('Hola, soy ' + (last.nombre || '') + '. Acabo de pedir presupuesto para la oferta «' + (last.oferta || '') + '» (ref. ' + (last.ref || '') + ').');
  }
  if (!reduce) {
    var c = $('[data-of-confetti]'), colors = ['#F5B700', '#0D014B', '#FFE08A', '#2A2190', '#9CC9FF'];
    for (var i = 0; i < 42; i++) {
      var p = document.createElement('i');
      p.style.left = Math.random() * 100 + '%';
      p.style.background = colors[i % colors.length];
      p.style.animationDelay = (Math.random() * 0.8) + 's';
      p.style.animationDuration = (2.2 + Math.random() * 1.6) + 's';
      c.appendChild(p);
    }
  }
  requestAnimationFrame(function () { form.scrollIntoView({ block: 'start', behavior: reduce ? 'auto' : 'smooth' }); });
  return;
}

/* =================== Pasos =================== */
root.classList.add('gt-js');
form.classList.add('gof-js');
var steps = $$('fieldset[data-step]'), total = steps.length, cur = 0;
var prev = $('[data-gt-prev]'), next = $('[data-gt-next]'), submit = $('[data-gt-submit]');
var count = $('[data-gt-count]'), bar = $('[data-gt-bar]'), err = $('[data-gt-err]');
function show(i) {
  var antes = cur;
  steps.forEach(function (s, k) { s.classList.toggle('is-active', k === i); s.classList.remove('gof-in', 'gof-back'); });
  if (steps[i] && antes !== i) { void steps[i].offsetWidth; steps[i].classList.add(i < antes ? 'gof-back' : 'gof-in'); }
  count.textContent = 'Paso ' + (i + 1) + ' de ' + total;
  bar.style.width = ((i + 1) / total * 100) + '%';
  prev.style.visibility = i === 0 ? 'hidden' : 'visible';
  next.hidden = i === total - 1;
  submit.hidden = i !== total - 1;
  err.hidden = true;
  cur = i;
}
function queja(el, msg) {
  err.textContent = msg; err.hidden = false;
  if (el) { el.classList.add('gof-bad'); el.focus(); }
  return false;
}
function valido(i) {
  $$('.gof-bad', steps[i]).forEach(function (el) { el.classList.remove('gof-bad'); });
  if (i === 0) {
    var ad = F('adultos');
    if (!(parseInt(ad.value, 10) >= 1)) return queja(ad, 'Indica al menos 1 adulto.');
  }
  if (i === total - 1) {
    var n = F('nombre'), a = F('apellidos'), t = F('tel'), pr = F('pre'), m = F('mail');
    if (n.value.trim().length < 2) return queja(n, 'Escribe tu nombre.');
    if (a.value.trim().length < 2) return queja(a, 'Escribe tus apellidos.');
    if (pr.value.replace(/\D/g, '').length < 1) return queja(pr, 'Escribe el prefijo de tu teléfono, por ejemplo +34.');
    if (t.value.replace(/\D/g, '').length < 6) return queja(t, 'Escribe tu teléfono completo.');
    if (!pintarMail(true)) return queja(m, 'Revisa tu email.');
  }
  return true;
}
next.addEventListener('click', function () {
  if (!valido(cur)) return;
  show(cur + 1);
  var f = $('input:not([type=hidden]):not([type=radio]), select, textarea, .gof-date', steps[cur]);
  if (f) f.focus({ preventScroll: true });
  if (form.getBoundingClientRect().top < 0) form.scrollIntoView({ block: 'start', behavior: reduce ? 'auto' : 'smooth' });
});
prev.addEventListener('click', function () { if (cur > 0) { show(cur - 1); if (form.getBoundingClientRect().top < 0) form.scrollIntoView({ block: 'start', behavior: reduce ? 'auto' : 'smooth' }); } });
form.addEventListener('input', function (e) { if (e.target.classList) e.target.classList.remove('gof-bad'); });
show(form.querySelector('.gt-err') ? total - 1 : 0);

/* =================== Calendario propio =================== */
var cal = $('[data-of-cal]');
var hoy = dia(new Date());
var maxD = null;
if (cal && cal.dataset.max) { var mx = cal.dataset.max.split('-'); maxD = new Date(+mx[0], +mx[1] - 1, +mx[2]); if (maxD < hoy) maxD = null; }
var R = { ida: null, vuelta: null, modo: 'ida', mes: new Date(hoy.getFullYear(), hoy.getMonth(), 1), foco: null, hover: null };
var pop = document.createElement('div');
pop.className = 'gof-cal';
pop.hidden = true;
pop.setAttribute('role', 'dialog');
pop.setAttribute('aria-modal', 'true');
pop.setAttribute('aria-label', 'Elegir fechas del viaje');
pop.innerHTML =
  '<div class="gof-cal-bg" data-cal-x></div>' +
  '<div class="gof-cal-box">' +
    '<div class="gof-cal-tabs">' +
      '<button type="button" data-cal-modo="ida"><small>Ida</small><b data-cal-v="ida">Elige</b></button>' +
      '<span aria-hidden="true">→</span>' +
      '<button type="button" data-cal-modo="vuelta"><small>Vuelta</small><b data-cal-v="vuelta">Elige</b></button>' +
    '</div>' +
    '<div class="gof-cal-head">' +
      '<button type="button" class="gof-cal-nav" data-cal-mes="-1" aria-label="Mes anterior"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m15 18-6-6 6-6"/></svg></button>' +
      '<b data-cal-titulo aria-live="polite"></b>' +
      '<button type="button" class="gof-cal-nav" data-cal-mes="1" aria-label="Mes siguiente"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m9 18 6-6-6-6"/></svg></button>' +
    '</div>' +
    '<div class="gof-cal-wd" aria-hidden="true"><span>L</span><span>M</span><span>X</span><span>J</span><span>V</span><span>S</span><span>D</span></div>' +
    '<div class="gof-cal-grid" role="grid" data-cal-grid></div>' +
    '<div class="gof-cal-foot"><span data-cal-info></span><div><button type="button" class="gof-cal-clear" data-cal-clear>Borrar</button><button type="button" class="gof-cal-ok" data-cal-ok>Listo</button></div></div>' +
  '</div>';
if (cal) cal.appendChild(pop);
var grid = $('[data-cal-grid]', pop), lastBtn = null;

function limite(d) { return d < hoy || (maxD && d > maxD); }
function pintarCampos() {
  ['ida', 'vuelta'].forEach(function (k) {
    var d = R[k];
    $('[data-of-show="' + k + '"]').textContent = d ? larga(d) : 'Elige el día';
    $('[data-of-open="' + k + '"]').classList.toggle('is-set', !!d);
    F(k).value = d ? ddmm(d) : '';
    $('[data-cal-v="' + k + '"]', pop).textContent = d ? corta(d) : 'Elige';
  });
  $$('[data-cal-modo]', pop).forEach(function (b) { b.classList.toggle('on', b.dataset.calModo === R.modo); b.setAttribute('aria-pressed', b.dataset.calModo === R.modo); });
  var info = $('[data-cal-info]', pop);
  info.textContent = R.ida && R.vuelta ? noches(R.ida, R.vuelta) + (noches(R.ida, R.vuelta) === 1 ? ' noche' : ' noches') : (R.modo === 'ida' ? 'Elige el día de ida' : 'Ahora, el día de vuelta');
}
function pintar(enfocar) {
  var y = R.mes.getFullYear(), mo = R.mes.getMonth();
  $('[data-cal-titulo]', pop).textContent = MESES[mo].charAt(0).toUpperCase() + MESES[mo].slice(1) + ' ' + y;
  var primero = new Date(y, mo, 1), off = (primero.getDay() + 6) % 7, diasMes = new Date(y, mo + 1, 0).getDate();
  var fin = R.vuelta || (R.modo === 'vuelta' && R.ida && R.hover && R.hover > R.ida ? R.hover : null);
  var h = '';
  for (var i = 0; i < off; i++) h += '<span class="gof-d gof-d-x" role="gridcell"></span>';
  for (var n = 1; n <= diasMes; n++) {
    var d = new Date(y, mo, n), k = clave(d), cls = 'gof-d', no = limite(d);
    if (mismo(d, hoy)) cls += ' is-hoy';
    if (mismo(d, R.ida)) cls += ' is-ini';
    if (mismo(d, fin)) cls += ' is-fin';
    if (R.ida && fin && d > R.ida && d < fin) cls += ' is-en';
    h += '<span role="gridcell"><button type="button" class="' + cls + '" data-d="' + k + '"' + (no ? ' disabled' : '') +
      ' aria-label="' + larga(d) + (mismo(d, R.ida) ? ', ida' : '') + (mismo(d, R.vuelta) ? ', vuelta' : '') + '"' +
      (mismo(d, R.ida) || mismo(d, R.vuelta) ? ' aria-pressed="true"' : '') + ' tabindex="-1">' + n + '</button></span>';
  }
  grid.innerHTML = h;
  var antes = new Date(y, mo, 0);
  $('[data-cal-mes="-1"]', pop).disabled = antes < hoy;
  $('[data-cal-mes="1"]', pop).disabled = !!(maxD && new Date(y, mo + 1, 1) > maxD);
  var foco = R.foco && R.foco.getMonth() === mo && R.foco.getFullYear() === y ? R.foco : null;
  if (!foco) { foco = (R.modo === 'vuelta' ? R.vuelta || R.ida : R.ida); if (!foco || foco.getMonth() !== mo || foco.getFullYear() !== y) foco = mismo(new Date(y, mo, 1), new Date(hoy.getFullYear(), hoy.getMonth(), 1)) ? hoy : new Date(y, mo, 1); }
  var fb = grid.querySelector('[data-d="' + clave(foco) + '"]:not(:disabled)') || grid.querySelector('.gof-d:not(:disabled):not(.gof-d-x)');
  if (fb) { fb.tabIndex = 0; if (enfocar) fb.focus({ preventScroll: true }); }
  pintarCampos();
}
function abrir(modo) {
  R.modo = modo === 'vuelta' && !R.ida ? 'ida' : modo;
  var base = (R.modo === 'vuelta' ? R.vuelta || R.ida : R.ida) || hoy;
  R.mes = new Date(base.getFullYear(), base.getMonth(), 1);
  R.foco = null; R.hover = null;
  lastBtn = document.activeElement;
  pop.hidden = false;
  document.documentElement.classList.add('gof-cal-open');
  requestAnimationFrame(function () { pop.classList.add('is-on'); });
  pintar(true);
}
function cerrar() {
  if (pop.hidden) return;
  pop.classList.remove('is-on');
  document.documentElement.classList.remove('gof-cal-open');
  setTimeout(function () { pop.hidden = true; }, reduce ? 0 : 180);
  if (lastBtn && lastBtn.focus) lastBtn.focus({ preventScroll: true });
}
function elegir(d) {
  if (R.modo === 'ida' || !R.ida || d < R.ida) {
    R.ida = d;
    if (R.vuelta && R.vuelta <= d) R.vuelta = null;
    R.modo = 'vuelta';
    R.foco = d; pintar(true);
    return;
  }
  if (mismo(d, R.ida)) return;
  R.vuelta = d; R.foco = d;
  pintar(false);
  setTimeout(cerrar, reduce ? 0 : 260);
}
if (cal) {
  $$('[data-of-open]').forEach(function (b) { b.addEventListener('click', function () { abrir(b.dataset.ofOpen); }); });
  pop.addEventListener('click', function (e) {
    var t = e.target.closest('button, [data-cal-x]');
    if (!t) return;
    if (t.hasAttribute('data-cal-x') || t.hasAttribute('data-cal-ok')) { cerrar(); return; }
    if (t.dataset.calMes) { R.mes = new Date(R.mes.getFullYear(), R.mes.getMonth() + +t.dataset.calMes, 1); R.foco = null; pintar(false); return; }
    if (t.dataset.calModo) { R.modo = t.dataset.calModo === 'vuelta' && !R.ida ? 'ida' : t.dataset.calModo; pintar(false); return; }
    if (t.hasAttribute('data-cal-clear')) { R.ida = R.vuelta = null; R.modo = 'ida'; pintar(false); return; }
    if (t.dataset.d) { var p = t.dataset.d.split('-'); elegir(new Date(+p[0], +p[1] - 1, +p[2])); }
  });
  grid.addEventListener('mouseover', function (e) {
    var t = e.target.closest('[data-d]');
    if (!t || R.modo !== 'vuelta' || !R.ida || R.vuelta) return;
    var p = t.dataset.d.split('-'), d = new Date(+p[0], +p[1] - 1, +p[2]);
    if (mismo(d, R.hover)) return;
    R.hover = d;
    $$('[data-d]', grid).forEach(function (b) {
      var q = b.dataset.d.split('-'), x = new Date(+q[0], +q[1] - 1, +q[2]);
      b.classList.toggle('is-en', x > R.ida && x < d);
      b.classList.toggle('is-fin', mismo(x, d) && d > R.ida);
    });
  });
  grid.addEventListener('keydown', function (e) {
    var t = e.target.closest('[data-d]'); if (!t) return;
    var mov = { ArrowLeft: -1, ArrowRight: 1, ArrowUp: -7, ArrowDown: 7 }[e.key];
    if (!mov) return;
    e.preventDefault();
    var p = t.dataset.d.split('-'), d = new Date(+p[0], +p[1] - 1, +p[2] + mov);
    if (limite(d)) return;
    R.foco = d;
    if (d.getMonth() !== R.mes.getMonth() || d.getFullYear() !== R.mes.getFullYear()) R.mes = new Date(d.getFullYear(), d.getMonth(), 1);
    pintar(true);
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !pop.hidden) cerrar(); });
  document.addEventListener('pointerdown', function (e) {
    if (pop.hidden || window.matchMedia('(max-width: 640px)').matches) return;
    if (!pop.contains(e.target) && !e.target.closest('[data-of-open]')) cerrar();
  });
  pintarCampos();
}

/* =================== Prefijo con bandera =================== */
var P = ('España|ES|34;Venezuela|VE|58;Colombia|CO|57;Panamá|PA|507;Estados Unidos|US|1;República Dominicana|DO|1;México|MX|52;Perú|PE|51;Ecuador|EC|593;Argentina|AR|54;Chile|CL|56;' +
'Portugal|PT|351;Reino Unido|GB|44;Francia|FR|33;Italia|IT|39;Alemania|DE|49;Albania|AL|355;Andorra|AD|376;Angola|AO|244;Arabia Saudí|SA|966;Argelia|DZ|213;Armenia|AM|374;Aruba|AW|297;Australia|AU|61;' +
'Austria|AT|43;Bélgica|BE|32;Belice|BZ|501;Bolivia|BO|591;Bosnia y Herzegovina|BA|387;Brasil|BR|55;Bulgaria|BG|359;Cabo Verde|CV|238;Canadá|CA|1;Catar|QA|974;China|CN|86;Chipre|CY|357;Corea del Sur|KR|82;' +
'Costa Rica|CR|506;Croacia|HR|385;Curazao|CW|599;Dinamarca|DK|45;Egipto|EG|20;El Salvador|SV|503;Emiratos Árabes Unidos|AE|971;Eslovaquia|SK|421;Eslovenia|SI|386;Estonia|EE|372;Filipinas|PH|63;Finlandia|FI|358;' +
'Georgia|GE|995;Grecia|GR|30;Guatemala|GT|502;Guinea Ecuatorial|GQ|240;Guyana|GY|592;Haití|HT|509;Honduras|HN|504;Hong Kong|HK|852;Hungría|HU|36;India|IN|91;Indonesia|ID|62;Irlanda|IE|353;Islandia|IS|354;' +
'Israel|IL|972;Jamaica|JM|1;Japón|JP|81;Jordania|JO|962;Kenia|KE|254;Letonia|LV|371;Líbano|LB|961;Lituania|LT|370;Luxemburgo|LU|352;Malasia|MY|60;Maldivas|MV|960;Malta|MT|356;Marruecos|MA|212;Mauricio|MU|230;' +
'Mónaco|MC|377;Montenegro|ME|382;Nicaragua|NI|505;Nigeria|NG|234;Noruega|NO|47;Nueva Zelanda|NZ|64;Países Bajos|NL|31;Paraguay|PY|595;Polonia|PL|48;Puerto Rico|PR|1;República Checa|CZ|420;Rumanía|RO|40;' +
'Senegal|SN|221;Serbia|RS|381;Singapur|SG|65;Sudáfrica|ZA|27;Suecia|SE|46;Suiza|CH|41;Tailandia|TH|66;Trinidad y Tobago|TT|1;Túnez|TN|216;Turquía|TR|90;Ucrania|UA|380;Uruguay|UY|598;Vietnam|VN|84')
  .split(';').map(function (r) { var a = r.split('|'); return { n: a[0], iso: a[1], d: a[2] }; });
var PRINCIPAL = { '1': 'US', '44': 'GB' };
var AREA1 = { '809': 'DO', '829': 'DO', '849': 'DO', '787': 'PR', '939': 'PR', '876': 'JM', '868': 'TT' };
function bandera(iso) { return iso && iso.length === 2 ? String.fromCodePoint(0x1F1E6 + iso.charCodeAt(0) - 65, 0x1F1E6 + iso.charCodeAt(1) - 65) : '🌐'; }
/* Imagen de bandera (Windows no muestra banderas con emoji) */
function banderaImg(iso) { return iso ? '<img src="https://flagcdn.com/w40/' + iso.toLowerCase() + '.png" alt="" width="22" height="16" loading="lazy">' : '<span class="gof-globe">🌐</span>'; }
function porIso(iso) { for (var i = 0; i < P.length; i++) if (P[i].iso === iso) return P[i]; return null; }
var pre = F('pre'), flag = $('[data-of-flag]'), dl = $('[data-of-prelist]');
if (dl) {
  var vistos = {}, frag = document.createDocumentFragment();
  P.forEach(function (p) {
    if (vistos[p.d]) return; vistos[p.d] = 1;
    var o = document.createElement('option'), q = PRINCIPAL[p.d] ? porIso(PRINCIPAL[p.d]) : p;
    o.value = '+' + p.d; o.label = bandera(q.iso) + ' ' + q.n; frag.appendChild(o);
  });
  dl.appendChild(frag);
}
function paisDe(v) {
  var dig = String(v || '').replace(/\D/g, '');
  if (!dig) return null;
  if (dig.charAt(0) === '1') return porIso(AREA1[dig.slice(1, 4)] || 'US');
  for (var len = Math.min(4, dig.length); len > 0; len--) {
    var cod = dig.slice(0, len);
    for (var i = 0; i < P.length; i++) if (P[i].d === cod) return PRINCIPAL[cod] ? porIso(PRINCIPAL[cod]) : P[i];
  }
  return null;
}
function pintarBandera() { if (!flag || !pre) return; var p = paisDe(pre.value), k = p ? p.iso : ''; if (flag.dataset.iso === k) return; flag.dataset.iso = k; flag.innerHTML = banderaImg(k); flag.title = p ? p.n : ''; }
if (pre) {
  pre.addEventListener('input', function () {
    var v = pre.value.replace(/[^\d+]/g, '').replace(/(?!^)\+/g, '');
    if (v && v.charAt(0) !== '+') v = '+' + v;
    if (v !== pre.value) pre.value = v;
    pintarBandera();
  });
  pre.addEventListener('focus', function () { pre.select(); });
  pre.addEventListener('blur', function () { if (pre.value === '+') pre.value = ''; pintarBandera(); });
  pintarBandera();
}
/* Si pegan el número con prefijo (+58 412…), se separa solo */
var tel = F('tel');
if (tel && pre) tel.addEventListener('change', function () {
  var v = tel.value.trim();
  if (!/^(\+|00)/.test(v)) return;
  var dig = v.replace(/^00/, '').replace(/\D/g, ''), p = paisDe(dig);
  if (p) { pre.value = '+' + p.d; tel.value = dig.slice(p.d.length); pintarBandera(); }
});

/* =================== Email comprobado =================== */
var mail = F('mail'), hint = $('[data-of-hint]');
var PERSONALES = /^(gmail\.com|googlemail\.com|hotmail\.(com|es|co\.uk|fr|it)|outlook\.(com|es)|live\.(com|es)|msn\.com|yahoo\.(com|es|co\.uk|fr)|ymail\.com|icloud\.com|me\.com|mac\.com|aol\.com|protonmail\.com|proton\.me|gmx\.(com|es|de)|zoho\.com|telefonica\.net|movistar\.es)$/;
var ERRATAS = {
  'gmial.com': 'gmail.com', 'gmai.com': 'gmail.com', 'gmal.com': 'gmail.com', 'gmaill.com': 'gmail.com', 'gnail.com': 'gmail.com', 'gamil.com': 'gmail.com',
  'gmail.co': 'gmail.com', 'gmail.con': 'gmail.com', 'gmail.cm': 'gmail.com', 'gmail.om': 'gmail.com', 'gmail.comm': 'gmail.com', 'gmail.es': 'gmail.com', 'gmail.cpm': 'gmail.com', 'gmail.vom': 'gmail.com',
  'hotmial.com': 'hotmail.com', 'hotmal.com': 'hotmail.com', 'hotmai.com': 'hotmail.com', 'hotmil.com': 'hotmail.com', 'hotmail.con': 'hotmail.com', 'hotmail.co': 'hotmail.com', 'hotmail.cm': 'hotmail.com', 'hormail.com': 'hotmail.com',
  'outlok.com': 'outlook.com', 'outloo.com': 'outlook.com', 'outlook.con': 'outlook.com', 'outlook.co': 'outlook.com',
  'yaho.com': 'yahoo.com', 'yahooo.com': 'yahoo.com', 'yahoo.con': 'yahoo.com', 'yahoo.co': 'yahoo.com',
  'iclod.com': 'icloud.com', 'icoud.com': 'icloud.com', 'icloud.con': 'icloud.com', 'live.con': 'live.com'
};
var SIN_PUNTO = { gmail: 'gmail.com', hotmail: 'hotmail.com', outlook: 'outlook.com', yahoo: 'yahoo.com', icloud: 'icloud.com', live: 'live.com' };
function revisaMail(v) {
  v = String(v || '').trim().toLowerCase();
  if (!v) return { ok: false, msg: 'Escribe tu email.' };
  var at = v.lastIndexOf('@');
  if (at < 1 || v.indexOf(' ') > -1) return { ok: false, msg: 'Escribe tu email completo, por ejemplo nombre@gmail.com' };
  var user = v.slice(0, at), dom = v.slice(at + 1);
  if (SIN_PUNTO[dom]) return { ok: false, msg: 'Falta el final del email.', sug: user + '@' + SIN_PUNTO[dom] };
  if (ERRATAS[dom]) return { ok: false, msg: 'Parece que hay un error en el email.', sug: user + '@' + ERRATAS[dom] };
  if (!/^[a-z0-9._%+\-]+$/.test(user) || !/^([a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z]{2,24}$/.test(dom)) return { ok: false, msg: 'El email no está completo. Revisa que termine en .com, .es u otra terminación.' };
  return { ok: true, tipo: PERSONALES.test(dom) ? 'personal' : 'empresa', dom: dom };
}
function pintarMail(final) {
  if (!mail || !hint) return true;
  var r = revisaMail(mail.value);
  hint.innerHTML = '';
  hint.className = 'gof-hint';
  if (!mail.value.trim() && !final) { hint.hidden = true; return false; }
  if (r.ok) {
    hint.hidden = false; hint.classList.add('is-ok');
    hint.textContent = r.tipo === 'personal' ? '✓ Correo personal' : '✓ Correo de empresa · ' + r.dom;
    return true;
  }
  if (!final && !r.sug && mail.value.indexOf('@') === -1) { hint.hidden = true; return false; }
  hint.hidden = false; hint.classList.add('is-bad');
  hint.appendChild(document.createTextNode(r.msg + ' '));
  if (r.sug) {
    var b = document.createElement('button');
    b.type = 'button';
    b.textContent = '¿Querías decir ' + r.sug + '?';
    b.addEventListener('mousedown', function (e) { e.preventDefault(); });
    b.addEventListener('click', function () { mail.value = r.sug; mail.classList.remove('gof-bad'); pintarMail(true); });
    hint.appendChild(b);
  }
  return false;
}
if (mail) {
  var mt;
  mail.addEventListener('input', function () { clearTimeout(mt); mt = setTimeout(function () { pintarMail(false); }, 400); });
  mail.addEventListener('blur', function () { if (mail.value.trim()) pintarMail(true); });
}

/* =================== Enviar =================== */
var ref = 'GT-' + Date.now().toString(36).slice(-3).toUpperCase() + Math.random().toString(36).slice(2, 4).toUpperCase();
F('ref').value = ref;
function pax() {
  var a = parseInt(F('adultos').value, 10) || 0, n = parseInt(F('ninos').value, 10) || 0;
  return a + (a === 1 ? ' adulto' : ' adultos') + (n ? ' · ' + n + (n === 1 ? ' niño' : ' niños') : '');
}
function alEnviar(e) {
  var hp = form.querySelector('[name="contact[Web]"]');
  if (hp && hp.value) { e.preventDefault(); return; }
  for (var i = 0; i < total; i++) if (!valido(i)) { e.preventDefault(); if (i !== cur) { show(i); valido(i); } return; }
  var nombre = F('nombre').value.trim();
  F('name').value = (nombre + ' ' + F('apellidos').value.trim()).trim();
  var p = F('pre').value.replace(/[^\d+]/g, ''); if (p.charAt(0) !== '+') p = '+' + p;
  F('pre').value = p;
  if (tel.value.trim().charAt(0) !== '+') tel.value = p + ' ' + tel.value.trim();
  if (mail) mail.value = mail.value.trim();
  store({
    ref: ref, nombre: nombre, pax: pax(),
    oferta: (form.querySelector('[name="contact[Oferta]"]') || {}).value || '',
    fechas: R.ida ? corta(R.ida) + (R.vuelta ? ' → ' + corta(R.vuelta) : '') : 'Por concretar'
  });
  submit.classList.add('is-sending');
  submit.setAttribute('aria-busy', 'true');
  submit.querySelector('span').textContent = 'Enviando…';
}
form.addEventListener('submit', alEnviar);
})();
